<template>
    <div>
        <table>
            <tr class="row" v-for="y of value.h" :key="y">
                <td class="col" v-for="x in value.w" :key="x" v-bind:class="value[(x-1)+(y-1)*value.w]"
                :style="{backgroundPosition:countBackgroundPosition(value[(x-1)+(y-1)*value.w]) }"
                >
                    <!--            <img src="../assets/img/puzzlebg.jpeg" alt="">-->
                </td>
            </tr>
        </table>

    </div>
</template>
<!--v-bind:style="{backgroundImage: 'url('+value[(x-1)+(y-1)*value.w]+')'}"></div>-->
<!--v-bind:style="{background: value[(x-1)+(y-1)*value.w]}"></div>-->
<script>
    export default {
        name: "TetrisBoard",
        props: ['value'],
        mounted() {
        },
        methods: {
            update() {
                this.$forceUpdate();
            },
            countBackgroundPosition(className){
                if(className.match('x')) {
                    let x = +(className.substring((className.indexOf('x')+1), className.indexOf('y')));
                    let y = +(className.substring((className.indexOf('y')+1), className.length))
                    return `${(40 - (x)*4)}vh ${18*4 - (y)*4}vh`;
                }
                else return `0 0`

            }
        },
    }
</script>

<style scoped>

</style>